import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define the API service
export const ormgarmenttypeApi = createApi({
  reducerPath: 'garmenttypeApi',
  baseQuery: btBaseQuery,
  tagTypes: ['GarmentType'], // Define the tag type for cache management and invalidation
  endpoints: (builder) => ({
    // Define the endpoints for your API
    findAllGarmentTypes: builder.query({
      query: (company) => `garmenttype/${company}`, // GET all garment types by company
      providesTags: ['GarmentType'] // Cache with the 'GarmentType' tag
    }),
    findGarmentTypeById: builder.query({
      query: (id) => `garmenttype/byid/${id}`, // GET garment type by ID
      providesTags: ['GarmentType'] // Cache with the 'GarmentType' tag
    }),
    insertGarmentType: builder.mutation({
      query: (garmentType) => ({
        url: 'garmenttype', // POST a new garment type
        method: 'POST',
        body: garmentType
      }),
      invalidatesTags: ['GarmentType'] // Invalidate the 'GarmentType' tag cache
    }),
    updateGarmentType: builder.mutation({
      query: (garmentType) => ({
        url: 'garmenttype', // PUT update garment type details
        method: 'PUT',
        body: garmentType
      }),
      invalidatesTags: ['GarmentType'] // Invalidate the 'GarmentType' tag cache
    }),
    deleteGarmentType: builder.mutation({
      query: (id) => ({
        url: `garmenttype/${id}`, // DELETE a garment type by ID
        method: 'DELETE'
      }),
      invalidatesTags: ['GarmentType'] // Invalidate the 'GarmentType' tag cache
    })
  })
});

// Export the auto-generated hooks for the endpoints
export const {
  useFindAllGarmentTypesQuery,
  useFindGarmentTypeByIdQuery,
  useInsertGarmentTypeMutation,
  useUpdateGarmentTypeMutation,
  useDeleteGarmentTypeMutation
} = ormgarmenttypeApi;
